var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"text-field-item mb-1",attrs:{"dense":"","outlined":"","hide-details":""},on:{"input":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }